import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import unregisterServiceWorker from 'src/unregisterServiceWorker';
import { history, store } from 'src/store';
import Router from 'src/Router';
import App from 'src/App';
import ScrollComponent from 'src/services/middleware/Scroll.component';
import GAListener from 'src/services/middleware/GAListener';
import 'moment/locale/es';

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <GAListener>
        <ScrollComponent>
          <App>
            {Router}
          </App>
        </ScrollComponent>
      </GAListener>
    </ConnectedRouter>
  </Provider>
  ,
  document.getElementById('root') as HTMLElement
);

unregisterServiceWorker();


// WEBPACK FOOTER //
// ./src/index.tsx